/** Capitalize */
const cap = <S extends string>(s: S): string extends S ? string : Capitalize<S> => {
  return (s.charAt(0).toUpperCase() + s.slice(1)) as Capitalize<S>;
};

export default cap;
